import {useEffect, useRef, useState} from 'react'
import classes from './Statistic.module.scss'
import {DirectionService} from '../../../api/directionService'
import {contractService} from '../../../api/contractService'
import {Controller, useForm} from 'react-hook-form'
import Select from 'react-select'
import html2pdf from 'html2pdf.js'
import * as XLSX from 'xlsx'
import {saveAs} from 'file-saver'
import {useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {toast} from 'react-toastify'

const Statistic = () => {
    const [hospitals, setHospitals] = useState([])
    const [contracts, setContracts] = useState([])
    const [tableValues, setTableValues] = useState([])
    const [showTable, setShowTable] = useState(false)
    const [search, setSearch] = useState()
    const {control, handleSubmit, register, watch} = useForm()
    const role = useSelector(state => state.login.userInfo.permissions.statistic)
    const navigate = useNavigate()

    const pdfRef = useRef()

    const downloadPDF = () => {
        pdfRef.current.classList.add('pdf-mode')

        const opt = {
            margin: 10,
            filename: 'table.pdf',
            image: {type: 'jpeg', quality: 0.98},
            html2canvas: {
                scale: 1.5,
                scrollY: 0
            },
            jsPDF: {
                unit: 'mm',
                format: 'a4',
                orientation: 'portrait'
            },
            pagebreak: {mode: ['css', 'legacy']}
        }

        html2pdf().set(opt).from(pdfRef.current).save()
            .then(() => pdfRef.current.classList.remove('pdf-mode'))
    }

    const exportToExcel = () => {

        const formattedData = tableValues.map(item => ({
            'Номер пацієнта': item.number,
            'Прізвище пацієнта': item.patient,
            'Відділення': item.departmentId,
            'Прізвище лікаря': item.docFormId,
            'Складність': item.difficultyLevel,
        }))

        const ws = XLSX.utils.json_to_sheet(formattedData)

        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, ws, 'Statistic')

        const excelBuffer = XLSX.write(wb, {bookType: 'xlsx', type: 'array'})

        const data = new Blob([excelBuffer], {type: 'application/octet-stream'})
        saveAs(data, 'statistic.xlsx')
    }

    useEffect(() => {
        if (!role){
            navigate('/Home')
            toast.error('В доступі відмовлено!')
        }
        DirectionService.getOptions()
            .then(res => {
                if (res?.data?.hospitals){
                    let arr = []
                    res.data.hospitals.map(el => {
                        if (el.registrationType == "COMPLETED"){
                            arr.push(el)
                        }
                    })
                    setHospitals(arr)
                }
            })
            .catch(console.error)
    }, [])

    useEffect(() => {
        let id = watch("hospitalId")
        setContracts([])
        if (id !== undefined){
            getContracts(id)
        }

    }, [watch("hospitalId")])

    const selectHospitalOptions = hospitals.map(el => ({
        value: el.id,
        label: el.name
    }))

    const selectContractOptions = contracts.map(el => ({
        value: el.id,
        label: el.name
    }))

    const onSubmit = (data) => {
        setSearch({
            dateFinished: (new Date(data.dateFinished + "T00:00:00Z")).toISOString(),
            dateStart: (new Date(data.dateStart + "T00:00:00Z")).toISOString(),
            contractId: data.contractId,
            hospitalId: data.hospitalId,
            status: data.status === 'all' ? '' : data.status,
            type: data.type === 'all' ? '' : data.type,
            level: data.level === 'all' ? '' : data.level
        })
    }

    useEffect(() => {
    if (search !== undefined){
        setTableValues([]) // очищення перед запитом
        setShowTable(false) // приховати таблицю на час запиту
        Statistic(search)
    }
}, [search])

    const Statistic = async(data) => {
        console.log(data)
        contractService.getStatistic(data.hospitalId, data.contractId, data.dateStart, data.dateFinished, data.status, data.type, data.level).then(res => {
            if (res){
                tableFormating(res.data)
            }
        })
    }

    useEffect(() => {
        if (tableValues.length > 0){
            setShowTable(true)
        }
    }, [tableValues])

    const getContracts = async(id) => {
        const res = await contractService.getHospitalContracts(id)
        if (res?.data){
            setContracts(res.data.data)
        }
    }

    useEffect(()=>{
        contracts.forEach(el=>{
            if(watch('contractId') === el.id){
                setContracts([el])
            }
        })
    },[watch('contractId')])

    const tableFormating = (data) => {
        let arr = []
        data.sort((a, b) => new Date(a.date) - new Date(b.date));
        data.map(el => {
            let date = new Date(el.createdAt).toLocaleDateString('uk-UA', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
            })
            let obj = {
                "id": el.id,
                "number": el.patient['cardNumber'],
                "patient": `${el.patient['lastName']} ${el.patient['name'].charAt()}. ${el.patient['middleName'].charAt()}.`,
                "departmentId": el?.department?.['name'] || '',
                "docFormId": el.activeDoc,
                "difficultyLevel": el.difficultyLevel || 'не визначена',
                "letter": (el?.department?.['name'])?.charAt(0)?.toUpperCase() || '',
                "date": date
            }
            arr.push(obj)
        })

        setTableValues(arr)
    }

    const selectContractStatus = [
        { value: 'finished', label: 'Завершені' },
        { value: 'all', label: 'Усі' }
    ];

    const selectContractType = [
        { value: 'CISH', label: 'CISH' },
        { value: 'ІГХ', label: 'ІГХ' },
        { value: 'Експрес', label: 'Експрес' },
        { value: 'Гістологія', label: 'Гістологія' },
        { value: 'all', label: 'Усі' }
    ];

    const selectContractLevel = [
        { value: 1, label: 1 },
        { value: 2, label: 2 },
        { value: 3, label: 3 },
        { value: 4, label: 4 },
        { value: 5, label: 5 },
        { value: 'all', label: 'Усі' }
    ];

    return (
        <div className={classes.container}>
            <form className={classes.options} onSubmit={handleSubmit(onSubmit)}>
                <Controller
                    control={control}
                    name="hospitalId"
                    render={({field: {onChange, value}}) => (
                        <Select
                            className={classes.select}
                            options={selectHospitalOptions}
                            value={selectHospitalOptions.find(opt => opt.value === value) || null}
                            onChange={opt => onChange(opt?.value)}
                            placeholder="Оберіть лікарню"
                            required
                            isClearable
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="contractId"
                    render={({field: {onChange, value}}) => (
                        <Select
                            className={classes.select}
                            options={selectContractOptions}
                            value={selectContractOptions.find(opt => opt.value === value) || null}
                            onChange={opt => onChange(opt?.value)}
                            placeholder="Оберіть контракт"
                            required
                            isClearable
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="status"
                    render={({field: {onChange, value}}) => (
                        <Select
                            className={classes.select}
                            options={selectContractStatus}
                            value={selectContractStatus.find(opt => opt.value === value) || null}
                            onChange={opt => onChange(opt?.value)}
                            placeholder="Оберіть статус"
                            required
                            isClearable
                        />
                    )}
                />
                <Controller
                    control={control}
                    name="type"
                    render={({field: {onChange, value}}) => (
                        <Select
                            className={classes.select}
                            options={selectContractType}
                            value={selectContractType.find(opt => opt.value === value) || null}
                            onChange={opt => onChange(opt?.value)}
                            placeholder="Оберіть тип"
                            required
                            isClearable
                        />
                    )}
                />
                {watch('type') === 'Гістологія' && <Controller
                    control={control}
                    name="level"
                    render={({field: {onChange, value}}) => (
                        <Select
                            className={classes.select}
                            options={selectContractLevel}
                            value={selectContractLevel.find(opt => opt.value === value) || null}
                            onChange={opt => onChange(opt?.value)}
                            placeholder="Оберіть категорію"
                            isClearable
                        />
                    )}
                />}
                <legend className={classes.legend} htmlFor='dateStart'></legend>
                <input className={classes.input} type='date' required {...register('dateStart')}/>
                <legend className={classes.legend} htmlFor='dateFinished'></legend>
                <input className={classes.input} type='date' required {...register('dateFinished')}/>
                <button className={classes.button} type="submit">Сформувати</button>
            </form>
            <div className={classes.statistic}>
                <div className={classes.statistic__buttons}>
                    <button className={classes.button} onClick={downloadPDF}>Експорт у PDF</button>
                    <button className={classes.button} onClick={exportToExcel}>Експорт у EXCEL</button>
                </div>
                <div className={classes.statistic__table} ref={pdfRef}>
                    {showTable && contracts.length !== 0 &&
                        <div className={classes.statistic__header}>
                            <h2>{contracts[0].hospital.name}</h2>
                            <div className={classes.statistic__headerBox}>
                                <div className={classes.statistic__headerBoxes}>
                                    <h3>Реєстр пацієнтів до: "{contracts[0].name.toLowerCase()}"</h3>
                                    <h3>№ {contracts[0].number}</h3>
                                </div>
                                <h3>Від 20.04.2025</h3>
                            </div>
                        </div>
                    }
                    <div className={classes.statistic__titles}>
                        <h3 className={classes.statistic__titlesbord}>№ пацієнта</h3>
                        <h3 className={classes.statistic__titlesbord}>Пацієнт</h3>
                        <h3 className={classes.statistic__titlesbord}>Відділення</h3>
                        <h3 className={classes.statistic__titlesbord}>Лікар</h3>
                        <h3 className={classes.statistic__titlesbord}>Складність</h3>
                    </div>
                    {showTable && tableValues.map((el, index) => (
                        <>
                            <div key={el.id} className={classes.statistic__values}>
                                <p className={classes.statistic__valuesbord}>{el.number}</p>
                                <p className={classes.statistic__valuesbord}>{el.patient}</p>
                                <p className={classes.statistic__valuesbord}>{el.departmentId}</p>
                                <p className={classes.statistic__valuesbord}>{el.docFormId}</p>
                                <p className={classes.statistic__valuesbord}>{el.difficultyLevel}</p>
                            </div>
                            {(index + 1) % 30 === 0 && <div style={{pageBreakAfter: 'always'}}></div>}
                        </>
                    ))}
                </div>

            </div>
        </div>
    )
}

export default Statistic
